// @flow
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import i18n from 'i18next';
import { translate } from 'react-i18next';
import styled, { withTheme } from 'styled-components';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Button from 'common/components/ui/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Divider from '@material-ui/core/Divider';

import { Icon } from '@material-ui/core';
import { getRadioUser } from 'statsradio/modules/authentication/session/selectors/sessionSelectors';
import { closeSession } from 'statsradio/modules/authentication/session/actions/sessionActions';
import RadioUser from 'statsradio/domain/RadioUser';
import { updateProfile } from 'statsradio/modules/userProfile/actions/userProfileActions';
import Permissions from '../../modules/authorisation/Permissions';
import AuthorisedComponent from '../../modules/authorisation/AuthorisedComponent';

const UserMenuLabel = styled.span`
  color: ${props => props.theme.V3.colors.text.tertiary};
`;

const SIcon = styled(Icon)`
  color: ${props => props.theme.V3.colors.text.tertiary};
`;

const SDivider = styled(Divider)`
  margin-top: 0px;
  margin-bottom: 0px;
`;

type Props = {
  theme: any,
  user: RadioUser,
  t: any,
  isAuthenticated: boolean;
  history: any;
  actions: {
    closeSession: () => mixed;
    updateProfile: (user: Object) => mixed;
  }
}

type State = {
  open: boolean,
  anchorEl: ?any,
};

class ProfileDropDown extends Component<Props, State> {

  constructor(props: Props) {
    super(props);

    this.state = {
      open: false,
      anchorEl: undefined,
    };
  }

  handleClick = (event) => {
    this.setState({
      anchorEl: event.currentTarget,
      open: true,
    });
  };

  handleRequestClose = () => {
    this.setState({
      open: false,
    });
  };

  onUserProfileClick = () => {
    this.handleRequestClose();
    this.props.history.push('/user-profile');
  };

  onUserManagementClick = () => {
    this.handleRequestClose();
    this.props.history.push('/user-management');
  };

  logout = () => {
    this.setState({ open: false });
    this.props.actions.closeSession();
  };

  updateUserProfile(user: Object) {
    const data = { name: user.name, surname: user.surname, language: i18n.language };

    this.props.actions.updateProfile(data);
  }

  render() {
    const { user, t, isAuthenticated } = this.props;
    if (!isAuthenticated || user === undefined) {
      return null;
    }

    return (
      <div>
        <Button
          variant={'text'}
          onClick={this.handleClick}
        >
          <UserMenuLabel>
            {user ? user.getName() : t('actions')}
          </UserMenuLabel>
          <SIcon>arrow_drop_down</SIcon>
        </Button>
        <Menu
          open={this.state.open}
          onClose={this.handleRequestClose}
          disableAutoFocusItem
          anchorEl={this.state.anchorEl}
          getContentAnchorEl={null}
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
        >
          {user &&
            <MenuItem onClick={this.onUserProfileClick}>{t('userProfile:profileMenuItem')}</MenuItem>
          }
          <AuthorisedComponent permissions={Permissions.MANAGE_USERS}>
            <MenuItem onClick={this.onUserManagementClick}>{t('menu.userManagement')}</MenuItem>
          </AuthorisedComponent>
          <SDivider />
          <MenuItem onClick={this.logout}>{t('signOut')}</MenuItem>
        </Menu>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: getRadioUser(state),
    isAuthenticated: state.session.isAuthenticated,
  };
}

function mapDispatchToProps(dispatch: *) {
  return {
    actions: bindActionCreators({ closeSession, updateProfile }, dispatch),
  };
}

export default withRouter(translate('general', 'userProfile')(connect(mapStateToProps, mapDispatchToProps)(withTheme(ProfileDropDown))));



// WEBPACK FOOTER //
// ./src/statsradio/layout/v2/ProfileDropDown.js